import Swal from "sweetalert2";

export const ConfirmButton = (
  conformBtnText,
  title = "Are you sure?",
  text = ""
) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: conformBtnText,
  });
};
